import { render, staticRenderFns } from "./AddBox.vue?vue&type=template&id=23e3f44a&scoped=true&"
import script from "./AddBox.vue?vue&type=script&lang=js&"
export * from "./AddBox.vue?vue&type=script&lang=js&"
import style0 from "./AddBox.vue?vue&type=style&index=0&id=23e3f44a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e3f44a",
  null
  
)

export default component.exports